// extracted by mini-css-extract-plugin
module.exports = {"emptyresults":"search-empty-view_emptyresults__lEauu","background":"search-empty-view_background__YAc9V"};